import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import md5 from 'md5';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password: md5(password), // 使用 md5 加密密码
        }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('DTC_USER_INFO', JSON.stringify(data.data));
        navigate('/');
      } else {
        setError(data.message || '登录失败，请检查用户名和密码');
      }
    } catch (err) {
      setError('网络错误，请稍后重试');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-lg p-6">
        <div className="bg-white rounded-2xl p-6 border-2 border-orange-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_16px_40px_rgb(0,0,0,0.06)] transition-shadow duration-300">
          {/* Logo and Title */}
          <div className="mb-6 text-center">
            <div className="flex items-center justify-center gap-1">
              <div className="inline-flex items-center justify-center w-16 h-16">
                <img src="/images/lzct_logo.png" alt="柳州文旅集团" className="w-16 h-16" />
              </div>
              <span className="text-3xl font-semibold text-gray-800" style={{ fontFamily: 'SimSun, serif' }}>
                文旅内控助手
              </span>
            </div>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            {error && (
              <div className="bg-red-50 text-red-500 p-4 rounded-xl text-sm border border-red-100">
                {error}
              </div>
            )}
            
            <div className="bg-gray-50/70 rounded-xl p-4 backdrop-blur-sm space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  用户名
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors duration-200"
                  placeholder="请输入用户名"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  密码
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors duration-200"
                  placeholder="请输入密码"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-orange-500 to-orange-400 text-white py-3 rounded-full hover:shadow-lg hover:shadow-orange-100 active:scale-95 transition-all duration-200 font-medium"
            >
              登录
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login; 